import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {AuthService} from '../services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private inj: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth header from the service.
    const authService = this.inj.get(AuthService);
    const authHeader = authService.getAuthorizationHeader();
    // Clone the request to add the new header.
    const authReq = req.clone({setHeaders: {Authorization: authHeader, 'Content-Type': 'application/json'}});
    // Pass on the cloned request instead of the original request.
    return next.handle(authReq);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/interceptors/auth.interceptor.ts